import { Component, type IComponentOptions } from "@eusoft/webapp-core";
import { forModel } from "@eusoft/webapp-jsx/Helpers";
import Chart, { type ChartConfiguration, type ChartConfigurationCustomTypesPerDataset, type ChartType, type DefaultDataPoint } from 'chart.js/auto';

export interface IChartOptions<
    TType extends ChartType = ChartType,
    TData = DefaultDataPoint<TType>,
    TLabel = unknown> extends IComponentOptions {

    config: ChartConfiguration<TType, TData, TLabel> | ChartConfigurationCustomTypesPerDataset<TType, TData, TLabel>;
}

export class ChartView<
    TType extends ChartType = ChartType,
    TData = DefaultDataPoint<TType>,
    TLabel = unknown>
    extends Component<IChartOptions<TType, TData, TLabel>> {

    constructor(options?: IChartOptions<TType, TData, TLabel>) {
        super();

        this.init(ChartView, {

            template: forModel<this>(m => <div visible={m.visible} className={m.className}>

            </div>),
            ...options
        });
    }

    override onMounted() {

        if (!this.canvas)
            this.canvas = document.createElement("canvas");

        this.context.element.appendChild(this.canvas);

        this.chart = new Chart(this.canvas, {
            ...this.config,
            options: {
                ...this.config?.options,
            }
        } as this["config"]);
    }

    canvas: HTMLCanvasElement;

    chart: Chart<TType, TData, TLabel>;

    config: ChartConfiguration<TType, TData, TLabel> | ChartConfigurationCustomTypesPerDataset<TType, TData, TLabel>;
}